import { Link } from 'react-router-dom';
import logo from '@/assets/damian-keyes-logo.png';

interface FooterProps {
  applyUrl?: string;
}

const companyLogos = [
  'Universal Music',
  'Sony Music',
  'Cinq Music',
  'Spotify',
  'Tidal',
  'BBC'
];

export function Footer({ applyUrl }: FooterProps) {
  return (
    <footer className="border-t border-white/[0.03] py-12 lg:py-16" style={{ background: 'linear-gradient(to bottom, hsl(0, 0%, 3%) 0%, hsl(0, 0%, 2%) 100%)' }}>
      {/* Logo and Tagline at Top - Compact */}
      <div className="max-w-5xl mx-auto px-6 mb-6">
        <Link to="/">
          <img 
            src={logo} 
            alt="Damian Keyes Logo" 
            className="w-32 lg:w-40 mb-2 -ml-1 invert cursor-pointer hover:opacity-80 transition-opacity"
          />
        </Link>
        <h3 className="text-sm lg:text-base font-medium text-white/70">
          The Artist Engine at DK Artists
        </h3>
        <p className="text-[10px] text-white/40 tracking-wide mt-1">
          You're Just One Song Away
        </p>
      </div>

      {/* Two-Column Layout */}
      <div className="max-w-5xl mx-auto px-6 mb-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Left: Company Logos */}
          <div>
            <p className="text-[10px] text-white/40 uppercase tracking-wider mb-3 font-mono">
              We've worked with
            </p>
            <div className="grid grid-cols-2 gap-2">
              {companyLogos.map((name) => (
                <div
                  key={name}
                  className="text-[11px] text-white/50 hover:text-white/70 transition-colors duration-200"
                >
                  {name}
                </div>
              ))}
            </div>
          </div>

          {/* Right: Navigation Links */}
          <div className="lg:text-right">
            <p className="text-[10px] text-white/40 uppercase tracking-wider mb-3 font-mono">
              Quick Links
            </p>
            <div className="flex flex-col gap-2 mb-4">
              <a 
                href="https://www.dk-mba.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[11px] text-white/50 hover:text-white/70 transition-colors duration-200"
              >
                The Academy
              </a>
              <a 
                href="https://www.damiankeyes.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[11px] text-white/50 hover:text-white/70 transition-colors duration-200"
              >
                Damian Keyes
              </a>
              <a 
                href="mailto:hello@dk-mba.com"
                className="text-[11px] text-white/50 hover:text-white/70 transition-colors duration-200"
              >
                Email Us
              </a>
            </div>
            
            <p className="text-[10px] text-white/40 uppercase tracking-wider mb-3 font-mono">
              Legal
            </p>
            <div className="flex flex-col gap-2">
              <a 
                href="/terms-and-conditions"
                className="text-[11px] text-white/50 hover:text-white/70 transition-colors duration-200"
              >
                Terms & Conditions
              </a>
              <a 
                href="/privacy-policy"
                className="text-[11px] text-white/50 hover:text-white/70 transition-colors duration-200"
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="max-w-5xl mx-auto px-6 mt-6 pt-6 border-t border-white/10">
        <p className="text-center text-[11px] text-white/40">
          © 2026 DK Music Business Academy Ltd
        </p>
      </div>
    </footer>
  );
}

export default Footer;
